/**
 * Utility functions for modal interactions
 */

/**
 * Scrolls to the top of a modal with fallback logic
 * @param {string} modalSelector - CSS selector for the modal content
 * @param {number} delay - Delay in milliseconds before scrolling (default: 100)
 */
export const scrollModalToTop = (modalSelector = '.ws-kbb-reviews-modal', delay = 100) => {
	setTimeout(() => {
		// Find the scrollable modal body - try different selectors
		const modalBody = document.querySelector('.common-modal__body');

		if (modalBody) {
			modalBody.scrollTop = 0;
		} else {
			// Fallback: try to find any scrollable parent
			const modalContent = document.querySelector(modalSelector);
			if (modalContent) {
				// Walk up the DOM tree to find the scrollable element
				let parent = modalContent.parentElement;
				while (parent) {
					if (parent.scrollHeight > parent.clientHeight) {
						parent.scrollTop = 0;
						break;
					}
					parent = parent.parentElement;
				}
			}
		}
	}, delay);
};
